<template>
  <svg width="172" height="140" viewBox="0 0 172 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M71.9153 10.2439C71.9153 13.0727 74.2084 15.3658 77.0372 15.3658H94.964C97.7928 15.3658 100.086 13.0727 100.086 10.2439H71.9153Z" :fill="color" />
    <path
      d="M76.1836 102.866C83.8512 102.866 88.1501 102.866 95.8177 102.866M73.1957 67.8658C73.1957 69.8661 73.1957 72.9878 73.1957 72.9878H98.8055C98.8055 72.9878 98.8055 69.8661 98.8055 67.8658M86.0006 48.6585V67.8658M86.0006 67.8658L90.6957 63.1707M86.0006 67.8658L81.3055 63.1707M71.9153 10.2439H65.5128C62.684 10.2439 60.3909 12.5371 60.3909 15.3658V63.1707M71.9153 10.2439V10.2439C71.9153 13.0727 74.2084 15.3658 77.0372 15.3658H94.964C97.7928 15.3658 100.086 13.0727 100.086 10.2439V10.2439M71.9153 10.2439H100.086M100.086 10.2439H106.488C109.317 10.2439 111.61 12.5371 111.61 15.3658V49.5122M60.3909 95.6098V104.146C60.3909 106.975 62.684 109.268 65.5128 109.268H106.488C109.317 109.268 111.61 106.975 111.61 104.146V68.7195"
      :stroke="color"
      stroke-width="3.41463"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M86.854 110.122C87.2808 113.679 91.3784 121.902 104.354 126.341C111.183 128.902 115.878 130.61 120.574 136.159M113.317 72.1341C110.756 66.5853 107.171 53.9512 113.317 47.8048C115.36 45.7625 117.945 43.9916 120.64 45.09C122.118 45.6922 122.566 47.45 122.497 49.0439C122.282 54.0643 122.972 62.2864 126.976 68.2927C132.952 77.2561 135.652 80.7253 136.366 85.3658C137.22 90.9146 137.647 106.28 147.037 115.671"
      :stroke="color"
      stroke-width="3.41463"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="54.408"
      y="83.1639"
      width="12.1399"
      height="8.53658"
      rx="4.26829"
      transform="rotate(25.6166 54.408 83.1639)"
      :stroke="color"
      stroke-width="3.41463"
    />
    <rect
      x="54.408"
      y="72.4536"
      width="15.5387"
      height="8.53658"
      rx="4.26829"
      transform="rotate(25.6166 54.408 72.4536)"
      :stroke="color"
      stroke-width="3.41463"
    />
    <rect
      x="54.408"
      y="61.1801"
      width="15.302"
      height="8.53658"
      rx="4.26829"
      transform="rotate(25.6166 54.408 61.1801)"
      :stroke="color"
      stroke-width="3.41463"
    />
    <path
      d="M60.8453 50.1868L54.4896 47.1393C52.3063 46.0925 49.6878 47.0138 48.6409 49.1971V49.1971C47.5966 51.3752 48.5108 53.9877 50.6855 55.0394L59.5565 59.3293"
      :stroke="color"
      stroke-width="3.41463"
    />
  </svg>
</template>

<script>
export default {
  name: 'DownloadSvg',
  props: {
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>

<style lang="scss" scoped></style>
